// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};


$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    app.initLightbox();
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initSpotlightJs();
    app.initAutocomplete();
    app.initStickyEl();
    app.initLightYoutubeEmbed();

    app.keepTokenAlive();
    //app.initTooltips();
    app.announcementBarDismiss();

    let googleMaps = require('./modules/google-maps')();
    googleMaps.assign();


    $(".megamenu").on("click", function(e) {
        e.stopPropagation();
    });

    let properties = require('./modules/properties')();
    properties.stampDutyCalculate();
    properties.stampDutyButton();
    properties.mortgageCalculate();
    properties.search();
    properties.locations();


    // Change both radius input fields when one is changed
    $("select[name='radius']").change(function(){
        $("select[name='radius']").val($(this).val());
    });


    $('.autosubmit').change(function(){
        $(this).parents('form').submit();
    });

    // Fixes issue with active class not removing when using inside slick slider
    $(".nav-pills .nav-link").click(function() {
        $(".nav-pills .nav-link").removeClass('active');
    });



});
